import script from "./UiAside.vue?vue&type=script&setup=true&lang=js"
export * from "./UiAside.vue?vue&type=script&setup=true&lang=js"

import "./UiAside.vue?vue&type=style&index=0&id=98c5dac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98c5dac2"]])

export default __exports__